export const resolveManualTransactionMutationOutcome = ({
  success = false,
  merchant = '',
  amount = null,
  errorMessage = null,
} = {}) => {
  if (!success) {
    return {
      success: false,
      outcome: 'manual_transaction_create_failed',
      toast: {
        type: 'error',
        headline: 'Could not add transaction',
        subheadline: errorMessage || 'Failed to create transaction',
      },
      shouldDispatchCreatedEvent: false,
    };
  }

  const safeMerchant = String(merchant || '').trim() || 'Transaction';
  const numericAmount = Number(amount);
  const formattedAmount = Number.isFinite(numericAmount)
    ? `$${Math.abs(numericAmount).toFixed(2)}`
    : null;

  return {
    success: true,
    outcome: 'manual_transaction_created',
    toast: {
      type: 'success',
      headline: 'Transaction created',
      subheadline: formattedAmount
        ? `${safeMerchant} · ${formattedAmount}`
        : safeMerchant,
    },
    shouldDispatchCreatedEvent: true,
  };
};
